subscription TravelAuthorizationTravelPlanReportStatus($id: UUID!) {
  travelAuthorizationTravelPlanReportStatus(id: $id) {
    document {
      id
    }
    status
  }
}
